export default "__VITE_PUBLIC_ASSET__6da47c16__"